import LogUtil from '../../../core/utils/LogUtil';

/**
 * 약국 설정 (대시보드) — 약국 토큰 필수, apiClient 가 자동 첨부
 * GET/PUT /pharmacy/settings
 * data: { pharmacy_info: {name, business_number, address, phone}, social_links: {instagram, threads, naver_blog, tiktok} }
 */
export class PharmacySettingsRepositoryImpl {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  async getSettings() {
    try {
      return await this.apiClient.get('/pharmacy/settings');
    } catch (error) {
      LogUtil.error('❌ [PharmacySettingsRepository] 약국 설정 조회 실패:', error);
      throw new Error(`약국 설정 조회 실패: ${error.message}`);
    }
  }

  /** business_number 는 서버가 무시(수정 불가) */
  async updateSettings(data) {
    try {
      return await this.apiClient.put('/pharmacy/settings', data);
    } catch (error) {
      LogUtil.error('❌ [PharmacySettingsRepository] 약국 설정 저장 실패:', error);
      throw new Error(`약국 설정 저장 실패: ${error.message}`);
    }
  }
}
